var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui grid"},[_c('div',{staticClass:"row"},[_c('h1',{staticClass:"ui huge header"},[_vm._v(_vm._s(_vm.$t('welcomeTitle')))])]),_vm._v(" "),_c('div',{staticClass:"ui divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('p',{staticClass:"ui negative message"},[_vm._v(_vm._s(_vm.$t('invalidTestCode')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f519434a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoTest.vue
// module id = null
// module chunks = 